import { DrawRuleProps } from 'modules/championship/ui/components/form-parts/rules/types';
import React, { ReactNode } from 'react';
import { UDFormLabeledInput } from 'ud-form/components';
import { UDSectionTitle } from 'ud-ui/components';

interface ExtendedDrawRuleProps extends DrawRuleProps {
  children?: ReactNode;
}

const DrawBase: React.FC<ExtendedDrawRuleProps> = ({ sportType = 'general', children }) => {
  return (
    <>
      <UDSectionTitle title="Ничья" icon="⚔️" tooltip="Настройка очков за ничью." />

      <UDFormLabeledInput
        name="settings.drawScore"
        placeholder="0 очков"
        label=""
        containerClassName="mb-4"
        inputContainerClassName="min-w-[120px]"
        alignRight={false}
        tooltip="Очки за ничью в основное время (в большинстве турниров за ничью дают 1 очко)."
        tooltipProps={{ position: 'input-right' }}
      />

      {/* Место для дополнительных полей */}
      {children}
    </>
  );
};

export default DrawBase;
